import { getSportsnewBetErrorMessage } from './sportsnewBetErrorMessage.js';

export function sportsnewPreviewErrorMessage(quoteError) {
  if (!quoteError) return '';
  const source = quoteError?.source ?? (
    typeof quoteError === 'string' ? { code: quoteError } : quoteError
  );
  return getSportsnewBetErrorMessage(
    source,
    '선택 조합을 확인해주세요',
  );
}

export function sportsnewPreviewPlacementGate({
  betType,
  quoteLoading,
  hasAuthoritativeQuote,
  quoteError,
  quoteErrorCode,
} = {}) {
  if (String(betType || '').toUpperCase() !== 'COMBO') return { ok: true };
  if (quoteLoading === true) {
    return { ok: false, message: '최종 배당을 확인 중입니다. 잠시 후 다시 시도해주세요' };
  }
  if (hasAuthoritativeQuote !== true) {
    return {
      ok: false,
      message: sportsnewPreviewErrorMessage(quoteError || quoteErrorCode)
        || '최종 배당을 확인하지 못했습니다. 선택 배당을 다시 확인해주세요',
    };
  }
  return { ok: true };
}
